import React, { Component } from 'react';

import './styles.css';

/**
 * A reusable play button.
 *
 * @typedef {Object} Props
 * @prop {Function} [onClick]
 *
 * @augments {Component<Props>}
 */
export default class PlayButton extends Component {

	/** @param {React.SyntheticEvent} event */
	handleClick = (event) => this.props.onClick && this.props.onClick(event);

	render () {
		return (
			<button
				className='PlayButton'
				onClick={this.handleClick}
				type='button'
			>
				<div className='PlayButton-arrow' />
			</button>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/PlayButton/PlayButton.js